import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class InvalidScheduledDueDateError extends CodedError {
  static get errorName() {
    return errorCodeTypes.invalidScheduledDueDateError.code;
  }

  constructor(message = errorCodeTypes.invalidScheduledDueDateError.message) {
    super(message);
    this.code = errorCodeTypes.invalidScheduledDueDateError.code;
    this.name = errorCodeTypes.invalidScheduledDueDateError.name;
  }
}
